import { forwardRef } from 'react'

const Button = forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  disabled = false,
  ...props 
}, ref) => {
  
  // Base styles for all buttons
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
  
  // Size variants
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl'
  }
  
  // Color variants with FORCED contrast ratios
  const variantStyles = {
    // Primary: Dark blue button with white text - GUARANTEED dark background
    primary: 'bg-blue-800 hover:bg-blue-900 text-white border-blue-800 hover:border-blue-900 focus:ring-blue-500 shadow-md hover:shadow-lg dark:bg-blue-600 dark:hover:bg-blue-700 dark:border-blue-600 dark:hover:border-blue-700 dark:text-white',
    
    // Secondary: Light button with DARK text - safe for any background
    secondary: 'bg-gray-200 hover:bg-gray-300 text-gray-900 border-gray-200 hover:border-gray-300 focus:ring-gray-500 shadow-sm hover:shadow-md dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white dark:border-gray-600 dark:hover:border-gray-500',
    
    // Outline: White background with DARK text - FORCED contrast
    outline: 'bg-white hover:bg-gray-100 text-gray-900 border-2 border-gray-700 hover:border-gray-800 focus:ring-gray-500 shadow-sm hover:shadow-md dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white dark:border-gray-400 dark:hover:border-gray-300',
    
    // Ghost: Transparent with DARK text
    ghost: 'bg-transparent hover:bg-gray-200 text-gray-900 border-transparent hover:border-gray-300 focus:ring-gray-500 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:border-gray-700',
    
    // Success: Dark green with white text
    success: 'bg-green-700 hover:bg-green-800 text-white border-green-700 hover:border-green-800 focus:ring-green-500',
    
    // Warning: Dark amber with white text  
    warning: 'bg-amber-600 hover:bg-amber-700 text-white border-amber-600 hover:border-amber-700 focus:ring-amber-500',
    
    // Error: Dark red with white text
    error: 'bg-red-700 hover:bg-red-800 text-white border-red-700 hover:border-red-800 focus:ring-red-500'
  }
  
  const combinedClassName = `${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`
  
  return (
    <button
      ref={ref}
      className={combinedClassName}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
